import axios from 'axios';
import { store } from '@/store';

export const apiGet = path => {
	const token = store.getters.jwtToken;
	return axios.get(store.getters.getAPI + '/' + path, { headers: { Authorization: token } });
};

export const apiGetDocs = path => {
	const token = store.getters.jwtToken;
	return axios.get(store.getters.getDOCUMENTS + '/' + path, { headers: { Authorization: token } });
};

export const apiPost = (path, payload) => {
	const token = store.getters.jwtToken;
	return axios.post(store.getters.getAPI + '/' + path, payload, { headers: { Authorization: token } });
};

export const apiPut = (path, payload) => {
	const token = store.getters.jwtToken;
	return axios.put(store.getters.getAPI + '/' + path, payload, { headers: { Authorization: token } });
};
